import { FC, useEffect, useState } from "react";
import styles from "./AdminSettings.module.scss";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../helpers/routes";
import { IModelNotVerificate } from "../../types/admin";
import { ErrorPage } from "../ErrorPage/ErrorPage";
import {
  getModelsBan,
  getModelsNotVerification,
  getModelsVerification,
  setIsBanned,
  setIsVerificate,
} from "../../api/user";
import check from "../../images/icons/check.svg";
import notCheck from "../../images/icons/close.svg";
import returnIcon from "../../images/icons/undo.svg";
import Loader from "../../components/Loader/Loader";

export const ModelBlockItem: FC<{
  type: "nicht" | "Verefifiziert" | "Verboten";
}> = ({ type }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModels, setIsModels] = useState<IModelNotVerificate[]>([]);
  const [isModelsVerf, setIsModelsVerf] = useState<IModelNotVerificate[]>([]);
  const [isModelsBan, setIsModelsBan] = useState<IModelNotVerificate[]>([]);
  const navigate = useNavigate();

  async function fetchDataVerf() {
    try {
      setIsLoading(true);
      const models: IModelNotVerificate[] = await getModelsVerification();
      setIsModelsVerf(models);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataNotVerif() {
    try {
      setIsLoading(true);
      const models: IModelNotVerificate[] = await getModelsNotVerification();
      setIsModels(models);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataBan() {
    try {
      setIsLoading(true);
      const models: IModelNotVerificate[] = await getModelsBan();
      setIsModelsBan(models);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchDataVerifBan(id: number) {
    try {
      setIsLoading(true);
      const body = {
        isBanned: true,
        reason: "",
      };
      await setIsBanned(body, id);
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
      fetchDataVerf();
    }
  }

  useEffect(() => {
    if (type === "nicht") {
      fetchDataNotVerif();
    }
    if (type === "Verboten") {
      fetchDataBan();
    }
    if (type === "Verefifiziert") {
      fetchDataVerf();
    }
  }, [type]);

  async function fetchDataVerif(idModels: number) {
    setIsLoading(true);

    try {
      const body = {
        status: "approved",
        reason: "",
      };
      await setIsVerificate(body, idModels);
      fetchDataNotVerif();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function fetchDataVerifCancel(idModels: number) {
    setIsLoading(true);

    try {
      const body = {
        status: "pending",
        reason: "",
      };
      await setIsVerificate(body, idModels);
      fetchDataNotVerif();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
    }
  }
  async function isNotBanned(idModels: number) {
    try {
      setIsLoading(true);
      const body = {
        isBanned: false,
        reason: "",
      };
      await setIsBanned(body, idModels);
      fetchDataBan();
    } catch {
      return <ErrorPage />;
    } finally {
      setIsLoading(false);
      fetchDataBan();
    }
  }

  if (isLoading)
    return (
      <div className="loader-container">
        <Loader size={100} borderWidth={7} />
      </div>
    );

  return (
    <div className={styles.container}>
      {type === "nicht" &&
        (isModels && isModels.length > 0 ? (
          isModels.map((model) => (
            <li className={styles.model} key={model.id}>
              {model.profileAvatar?.avatarUrl ? (
                <img
                  onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
                  className={styles.model_image}
                  src={model.profileAvatar.avatarUrl}
                  alt="Photo"
                />
              ) : (
                <div className={styles.photo__placeholder}></div>
              )}
              <div
                className={styles.container_text}
                onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
              >
                <p className={styles.model_text}>
                  {model.firstName + " " + model.lastName}
                </p>
                <p className={styles.model_text}>{model.email}</p>
                <p className={styles.model_text}>{model.gender}</p>
              </div>
              <div>
                <img
                  src={check}
                  alt="IConVer"
                  className={styles.icon}
                  onClick={() => fetchDataVerif(model.id)}
                />
                <img
                  src={notCheck}
                  alt="IConNotVer"
                  className={styles.icon}
                  onClick={() => fetchDataVerifCancel(model.id)}
                />
              </div>
            </li>
          ))
        ) : (
          <p className={styles.placeholder}>
            Keine Modelle, die auf Verifizierung warten
          </p>
        ))}
      {type === "Verefifiziert" &&
        (isModelsVerf && isModelsVerf.length > 0 ? (
          isModelsVerf.map((model) => (
            <li className={styles.model} key={model.id}>
              {model.profileAvatar?.avatarUrl ? (
                <img
                  className={styles.model_image}
                  src={model.profileAvatar.avatarUrl}
                  alt="Photo"
                  onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
                />
              ) : (
                <div className={styles.photo__placeholder}></div>
              )}
              <div
                className={styles.container_text}
                onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
              >
                <p className={styles.model_text}>
                  {model.firstName + " " + model.lastName}
                </p>
                <p className={styles.model_text}>{model.email}</p>
                <p className={styles.model_text}>{model.gender}</p>
              </div>
              <div>
                <img
                  src={notCheck}
                  alt="IConNotVer"
                  className={styles.icon}
                  onClick={() => fetchDataVerifBan(model.id)}
                />
              </div>
            </li>
          ))
        ) : (
          <p className={styles.placeholder}>Keine verifizierten Modelle</p>
        ))}
      {type === "Verboten" &&
        (isModelsBan && isModelsBan.length > 0 ? (
          isModelsBan.map((model) => (
            <li className={styles.model} key={model.id}>
              {model.profileAvatar?.avatarUrl ? (
                <img
                  onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
                  className={styles.model_image}
                  src={model.profileAvatar.avatarUrl}
                  alt="Photo"
                />
              ) : (
                <div className={styles.photo__placeholder}></div>
              )}
              <div
                className={styles.container_text}
                onClick={() => navigate(`${ROUTES.models}/${model.id}`)}
              >
                <p className={styles.model_text}>
                  {model.firstName + " " + model.lastName}
                </p>
                <p className={styles.model_text}>{model.email}</p>
                <p className={styles.model_text}>{model.gender}</p>
              </div>
              <img
                src={returnIcon}
                alt="cancelIcon"
                className={styles.icon}
                onClick={() => isNotBanned(model.id)}
              />
            </li>
          ))
        ) : (
          <p className={styles.placeholder}>Keine gesperrten Modelle</p>
        ))}
    </div>
  );
};
